
<div class="header">Search</div>



  
  <div class="tab-container full-size">

  <mat-tab-group [selectedIndex]="selectedTabIndex" mat-stretch-tabs="false" mat-align-tabs="start" class="xxx">
    <mat-tab label="Assets">
      <asset-search />
    </mat-tab>
    <mat-tab label="Sites and Locations">
      <site-search />
    </mat-tab>      
    <mat-tab label="Customers">
      <customer-search />
    </mat-tab>
  </mat-tab-group>

  </div> 
